<!--底图组件-->
<template>
  <div class="mapBox">
      <div class="mapTitle">{{D3Config.title}}</div>
      <div class="switchBox1">
        <div>
          <el-card class="card-imgs" title="屏蔽告警" :style="{background: workerGJShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/gaojing.png" width="30" @click="iconClick('屏蔽告警')"/>
          </el-card>
        </div>
          <el-card class="card-imgs" title="作业" :style="{background: jobSlipShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/zuoye.png" width="30" @click="iconClick('作业')"/>
          </el-card>

          <el-card class="card-imgs" title="摄像头" :style="{background: cameraShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/ic_video.svg" width="30" @click="iconClick('摄像头')"/>
          </el-card>
          <el-card class="card-imgs" title="人员" :style="{background: workerShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/ic_otm.svg" width="30" @click="iconClick('人员')"/>
          </el-card>
          <el-card class="card-imgs" title="电子围栏" :style="{background: eleFenceShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/electronics.png" width="30" @click="iconClick('电子围栏')"/>
          </el-card>
          <el-card class="card-imgs" title="作业票" :style="{background: workOrderShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/workOrder.png" width="30" @click="iconClick('作业票')"/>
          </el-card>
          <el-card class="card-imgs" title="四色图" :style="{background: fourColorShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/fourColor.png" width="30" @click="iconClick('四色图')"/>
          </el-card>
          <el-card class="card-imgs" title="屏蔽报警" :style="{background: handleShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/yinhuan.png" width="30" @click="iconClick('屏蔽报警')"/>
          </el-card>
          <el-card class="card-imgs" title="实时数据" :style="{background: realDataShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/实时数据.png" width="30" @click="iconClick('实时数据')"/>
          </el-card>
          <el-card class="card-imgs" title="设备数据" :style="{background: deviceDataShow ? '#394d6b' : '#fff'}">
            <img src="../../../assets/img/map/传感器设备.png" width="30" @click="iconClick('设备数据')"/>
          </el-card>
      </div>
    <div class="switchBox2">
      <div>
        <el-card class="card-imgs" title="告警" :style="{background: gjShow ? '#394d6b' : '#fff'}">
          <img v-if="gjDataNum==0"  src="../../../assets/img/map/gaojing.png" width="30" @click="iconClick('告警')"/>
          <img v-if="gjDataNum>0"  src="../../../assets/img/map/gaojing2.png" width="30" @click="iconClick('告警')"/>
        </el-card>
      </div>
      <el-card class="card-imgs" title="历史轨迹" :style="{background: hismodel ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/guiji.png" width="30" @click="iconClick('历史轨迹')"/>
      </el-card>
      <el-card class="card-imgs" title="监控" :style="{background: dataMonitorShow ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/jiankong.png" width="30" @click="iconClick('监控')"/>
      </el-card>
      <el-card class="card-imgs" title="区域" :style="{background: boxListShow ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/quyu.png" width="30" @click="iconClick('区域')"/>
      </el-card>
      <el-card class="card-imgs" title="人数统计" :style="{background: peopleNum ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/renshu.png" width="30" @click="iconClick('人数统计')"/>
      </el-card>
      <el-card class="card-imgs" title="维度" :style="{background: d23model ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/weidu.png" width="30" @click="iconClick('维度')"/>
      </el-card>
      <el-card class="card-imgs" title="电子围栏配置" :style="{background: elemodel ? '#394d6b' : '#fff'}">
        <img src="../../../assets/img/map/weilan.png" width="30" @click="iconClick('电子围栏配置')"/>
      </el-card>
    </div>

      <div id="gisContainer"></div>

      <Worker ref="worker" />
      <Count v-show="countShow" ref="count"></Count>
      <DataMonitor v-if="isInitComplete" v-show="dataMonitorShow" ref="dataMonitor"/>
      <JobSlip v-show="jobSlipShow" ref="jobSlip"/>
      <Statistics v-show="peopleNum" ref="Statistics"/>
      <HiddenDanger v-show="hiddenDangerShow" ref="hiddenDanger"/>
      <Gaojing v-show="gjShow" ref="gaojing"/>
      <BoxList ref="boxer" v-show="boxListShow"></BoxList>
      <GltfList ref="gltf"></GltfList>
      <BoxAdd v-if="getter_addBoxWindow_Visual"></BoxAdd>
      <Toogle23D ref="d23"></Toogle23D>
      <BoxDetail></BoxDetail>
      <MonitorDetail></MonitorDetail>
      <Ele ref="eledenfence" v-if="isInitComplete"></Ele>
      <audio style="display: none;" autoplay src="@/assets/audio/alarm_sound.mp3" controls="controls" ref='audio1'></audio>
      <audio style="display: none;" autoplay src="@/assets/audio/alarm_sound.mp3" controls="controls" ref='audio2'></audio>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Worker from "components/worker.vue"
import JobSlip from "components/jobSlip.vue"
import Statistics from "components/statistics.vue"
import DataMonitor from "components/dataMonitor.vue"
import MonitorDetail from "components/monitorDetail.vue"
import HiddenDanger from "components/hiddenDanger.vue"
import Gaojing from "components/gaojing.vue"
import Count from "components/count.vue"
import BoxList from "components/window/box/boxList.vue"
import BoxAdd from "components/window/box/boxAdd.vue"
import Toogle23D from "components/toolbar/toggle23D.vue"
import GltfList from "components/window/gltf/gltfList.vue"
import BoxDetail from "components/boxDetail.vue"
import Ele from "components/eleDenfence.vue"
import {
  Viewer,
  Cartesian3,
  Ion,Ellipsoid,
  WebMapTileServiceImageryProvider, ScreenSpaceEventHandler, ScreenSpaceEventType, TileMapServiceImageryProvider,UrlTemplateImageryProvider,createTileMapServiceImageryProvider
} from 'cesium';
import * as Cesium from 'cesium';
// import { getChannelrecord } from "@/api/BoxData.js";
import { getPolice } from "@/api/worker.js"
import { getChannelrecordNew,findHasMarkPointList,findPointDetails } from "@/api/BoxData.js";
import cesiumUtil from '../../../utils/cesiumUtils';
import viewOption from '../../../utils/viewOptions';


import FourColorLayer from './layer/fourColorLayer';
import WorkerLayer from './layer/workerLayer';
import RiskAreaLayer from './layer/eleFenceLayer';
import CameraLayer from './layer/cameraLayer';
import WorkOrderLayer from './layer/workOrderLayer';
import AlarmLayer from './layer/alarmLayer';
import DeviceDataLayer from './layer/deviceDataLayer';
import DeviceLayer from './layer/deviceLayer';
import CONSTANTS from "./constants";
import Overlay from './overlay/Overlay.js';
import MapUtil from './util/mapUtil';
import $ from 'jquery';
export default {
  name: 'Map',
  computed:{
    ...mapGetters({
      getter_addBoxWindow_Visual:'getter_addBoxWindow_Visual',

    })
  },
  components: {
    Worker,
    DataMonitor,
    HiddenDanger,
    Statistics,
    JobSlip,
    Gaojing,
    BoxList,
    GltfList,
    BoxAdd,
    Toogle23D,
    BoxDetail,
    Count,
    Ele,
    MonitorDetail
  },
  data(){
    return {
      wranSetInterval: null,
      workerGJShow: false, // 屏蔽告警
      handleShow: false, // 屏蔽报警
      fourColorShow: true, // 是否显示四色图
      workerShow: true, // 是否显示人员
      eleFenceShow: true, // 是否显示电子围栏
      cameraShow: true, // 是否显示摄像头
      workOrderShow:true,//是否显示作业票
      dataMonitorShow: false, // 数据监控
      hiddenDangerShow: false, // 隐患排查
      jobSlipShow: false, // 作业票
      peopleNum: false, // 人员统计
      countShow:false,// 数量显隐
      gjShow:false,// 告警显隐
      gjDataNum:0,//告警数量
      boxListShow:false,// 罩子列表显隐
      gltfListShow:false,// 模型显隐
      d23model:false,// 23d
      hismodel: false, // 轨迹
      elemodel:false,// 电子围栏配置
      boxer: false, // 四色图
      realDataShow:true,//实时数据
      deviceDataShow:true,//传感器设备数据
      electronics:false,// 电子围栏
      tjfxmodel:false,// 统计分析
      isInitComplete:false,//是否加载完成
    }
  },
  methods:{

    iconClick(item) {
      let self=this;
      MapUtil.closeOverlay();
      if (item === '区域') {
        this.boxListShow = !this.boxListShow
        //this.$refs.boxer.showBoxDraw();
      } else if (item === '告警') {
        this.gjShow = !this.gjShow
      } else if (item === '历史轨迹') {
        this.hismodel = !this.hismodel
        if (this.hismodel) {
          this.$refs.worker.checkHistory()
        }
      } else if (item === '维度') {
        this.d23model = !this.d23model
        this.$refs.d23.toggleHandler(this.d23model)
      } else if (item === '人数统计') {
        this.peopleNum = !this.peopleNum
      } else if (item === '监控') {
        this.dataMonitorShow = !this.dataMonitorShow
      } else if (item === '作业') {
        this.jobSlipShow = !this.jobSlipShow
      } else if (item === '隐患') {
        // this.hiddenDangerShow = !this.hiddenDangerShow
      } else if (item === '电子围栏配置') {
        this.elemodel = !this.elemodel
        this.$refs.eledenfence.toggle()
      } else if (item === '人员') {
        this.workerShow = !this.workerShow
        this.workerLayer && this.workerLayer.setVisible(this.workerShow)
      }  else if (item === '电子围栏') {
        this.eleFenceShow = !this.eleFenceShow
        this.eleFenceLayer && this.eleFenceLayer.setVisible(this.eleFenceShow)
      }  else if (item === '摄像头') {
        this.cameraShow = !this.cameraShow
        this.cameraLayer && this.cameraLayer.setVisible(this.cameraShow)
      } else if (item === '作业票') {
        this.workOrderShow = !this.workOrderShow
        this.workOrderLayer && this.workOrderLayer.setVisible(this.workOrderShow)
      } else if (item === '四色图'){
        this.fourColorShow = !this.fourColorShow
        this.fourColorLayer && this.fourColorLayer.setVisible(this.fourColorShow);
      }else if (item === '实时数据'){
        this.realDataShow = !this.realDataShow;
        this.deviceDataLayer && this.deviceDataLayer.setVisible(this.realDataShow);
      }else if (item === '设备数据'){
        this.deviceDataShow = !this.deviceDataShow;
        this.deviceLayer && this.deviceLayer.setVisible(this.deviceDataShow);
      } else if (item === '屏蔽报警'){
        this.handleShow = !this.handleShow
        if (this.handleShow) {
          this.wranSetInterval&&clearInterval(this.wranSetInterval);
          this.wranSetInterval = setInterval(() => {
            let formData = new FormData();
            formData.append('isDeal', 0);
            formData.append('curPage', 1);
            formData.append('limit', 1000000);
              // getChannelrecord(data).then((res) => {
              getChannelrecordNew(formData).then((res) => {
                if (res.data.data.length > 0) {
                  self.$refs.audio1.play();
                  self.alarmLayer.addEntities(res.data.data,this.$refs.boxer.allBoxEntitys);
                }
              });
          }, 6000)
        } else {
          clearInterval(this.wranSetInterval);
          this.alarmLayer.clearLayer();
        }
      }else if (item === '屏蔽告警'){
        this.workerGJShow = !this.workerGJShow
        if (this.workerGJShow) {
          this.workerWarnSetInterval&&clearInterval(this.workerWarnSetInterval);
          this.workerWarnSetInterval = setInterval(() => {
            getPolice(self.D3Config.username, self.D3Config.password,null,1).then(res => {//最近1天告警数据
              if (res.data.data.length > 0&&self.$refs.worker.workersData) {
                self.$refs.audio2.play();
                let workers=[];
                self.$refs.worker.workersData.map(item => {
                  let worker={...item};
                  let worker1=res.data.data.filter(item1=>item1.deviceNo==item.deviceNo);
                  if(worker1.length>0){
                    worker.workStatus=2;
                  }
                  workers.push(worker);
                });
                self.workerLayer.addEntities(workers);
              }

            });
          }, 3000)
        } else {
          self.workerWarnSetInterval&&clearInterval(self.workerWarnSetInterval);
          self.workerLayer.addEntities(self.$refs.worker.workersData);
        }
      }
      // else if (item === '统计分析') {
      //   this.hiddenDangerShow = !this.hiddenDangerShow
      // }
    },
    openHistory() {
      this.$refs.worker.checkHistory()
    },
    init() {
      let infos = JSON.parse(localStorage.getItem('D3Config'));
      if(Object.keys(infos).length) {
        this.D3Config.default.models = infos.models;
        // this.D3Config.default.models = infos.models.map(v => {
        //   let item = {}
        //   item.id = v.id;
        //   item.name = v.type;
        //   item.coors = [Number(infos.longitude), Number(infos.latitude)]
        //   item.heading = 90;
        //   item.pitch = 90;
        //   item.scale = 0.001;
        //   item.rotateZ = 75.4;
        //   item.modelUrl = `/v1${v.url}`;
        //   return item;
        // })
        this.D3Config.default.title = infos.name
        this.D3Config.default.base_url = infos.serviceIp
        this.D3Config.default.username = infos.serviceUserName
        this.D3Config.default.password = infos.servicePassword
        this.D3Config.default.Camera.center[0] = Number(infos.longitude)
        this.D3Config.default.Camera.center[1] = Number(infos.latitude)
      }
    },
    //折叠gltf
    toggleGltf(){
      //折叠模型显隐
      this.$refs.gltf.toggleGltfDraw(this.gltfListShow)
    },
    //23d
    toggle23D(){
      this.$refs.d23.toggleHandler(this.d23model)
    },
    toggleBox(){
        this.$refs.boxer.showBoxDraw()
    },
    initScene(){
      //初始化viewer
      Ion.defaultAccessToken = this.D3Config.IonToken
      let V = new Viewer('gisContainer',viewOption);
      // V.imageryLayers.addImageryProvider(new WebMapTileServiceImageryProvider({
      //   //影像
      //   url: "https://t4.tianditu.gov.cn/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=c6b646f2d0b02ff507effd9221b21c66",
      //   layer: "tdtCiaLayer",
      //   style: "default",
      //   format: "image/jpeg",
      //   maximumLevel:18,
      //   tileMatrixSetID: "GoogleMapsCompatible",
      //   show: true
      // }));
      V.imageryLayers.addImageryProvider(new WebMapTileServiceImageryProvider({
        //影像注记
        url: "https://t4.tianditu.gov.cn/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default.jpg&tk=c6b646f2d0b02ff507effd9221b21c66",
        layer: "tdtCiaLayer",
        style: "default",
        format: "image/jpeg",
        maximumLevel:18,
        tileMatrixSetID: "GoogleMapsCompatible",
        show: true
      }));
      let manufacturer = localStorage.getItem('manufacturer');
      let self=this;
      if(manufacturer) {
        let path='/static/3dtiles/'+manufacturer+'/tileset.json';
        $.getJSON(path,{},function (data,status,error) {
          //加载3dtiles
          let palaceTileset = new Cesium.Cesium3DTileset({
            url: path
          })
          self.D3Config.tiles=palaceTileset;
          V.scene.primitives.add(palaceTileset);
        }).fail(function(jqXHR,status,error){
          let infos = JSON.parse(localStorage.getItem('D3Config'));
          infos.models.map(item => {
            let lnglat0=item.coor.split(",");//左下角
            let lnglat1=item.coor1.split(",");//右上角
            if(lnglat0.length>1&&lnglat1.length>1&&item.url){
              //添加一个图层，在特定位置绘制一个图片
              V.imageryLayers.addImageryProvider(new Cesium.SingleTileImageryProvider({
                url : `/v1${item.url}`,
                rectangle : Cesium.Rectangle.fromDegrees(lnglat0[0],lnglat0[1], lnglat1[0],lnglat1[1])
              }));
            }
          })

        })
      }

      // let V = new Viewer('gisContainer',{
      //   imageryProvider: new TileMapServiceImageryProvider({
      //     url: 'http://localhost:8080/static/changzhou_tms',
      //     ellipsoid:Ellipsoid.WGS84,
      //     credit : 'Black Marble imagery courtesy NASA Earth Observatory'
      //   }),
      //   baseLayerPicker:false
      // });
      // let V = new Viewer('gisContainer',{
      //     imageryProvider: new UrlTemplateImageryProvider({
      //       url: "/tiles/jiangsu/tiles/{z}/{x}/{y}.png"
      //     }),
      //     baseLayerPicker:false
      // });
      V.scene.globe.enableLighting=false;

      this.D3Config.Viewer=V;
      window.gisViewer=V;


      document.getElementsByClassName('cesium-viewer-bottom')[0].style.display ='none';
      //初始化相机
      let camera=this.D3Config.Camera;
      let positionParams={
        lon:camera.center[0],
        lat:camera.center[1],
        height:camera.height,
        heading:camera.heading,
        pitch:camera.pitch,
        roll:camera.roll,
      };
      // console.log(positionParams, 111)
      cesiumUtil.initialCameraPosition(V,positionParams)
      //显示刷新率和帧率
      // V.scene.debugShowFramesPerSecond = true;


      //冒泡
      var infoDiv = '<div id="popupInfo" class="amap-info" style="position: absolute;width:auto;z-index: 100;"><div>';
      $('#gisContainer').append(infoDiv);
      let overlay = new Overlay({ viewer: window.gisViewer, element: document.getElementById('popupInfo') });
      MapUtil.setOverlay(overlay);

      //点击事件
      var handler =new ScreenSpaceEventHandler(window.gisViewer.scene.canvas);
      handler.setInputAction(function (movement) {
        var pick = window.gisViewer.scene.pick(movement.position);
        overlay.close();
        if (pick&&pick.id) {
          if(pick.id.attributes.layerName===CONSTANTS.LAYER.DEVICE){
            findPointDetails(pick.id.attributes.id).then((res) => {
              if (res.data.data) {
                let attributes={...pick.id.attributes,...res.data.data};
                pick.id.attributes=attributes;
                MapUtil.openOverlay(pick.id);
              }
            });
          }else{
            MapUtil.openOverlay(pick.id);
          }
        }
      }, ScreenSpaceEventType.LEFT_CLICK);

      //四色图图层
      this.fourColorLayer = new FourColorLayer({ layerName: CONSTANTS.LAYER.FOURCOLOR});
      //报警图层
      this.alarmLayer = new AlarmLayer();
      //设备数据图层
      this.deviceDataLayer = new DeviceDataLayer();
      //电子围栏图层
      this.eleFenceLayer = new EleFenceLayer({ layerName: CONSTANTS.LAYER.ELEFENCE});
      //摄像头图层
      this.cameraLayer = new CameraLayer();
      //作业票图层
      this.workOrderLayer = new WorkOrderLayer();
      //员工图层
      this.workerLayer = new WorkerLayer({ layerName: CONSTANTS.LAYER.WORKER});
      //设备图层
      this.deviceLayer = new DeviceLayer();
      //查询标记过的采集设备列表
      findHasMarkPointList().then((res) => {
        this.deviceLayer.addEntities(res.data.data);
      });
      this.isInitComplete=true;
    },
  },
  created(){
  },
  mounted(){
    let self=this;

    this.$nextTick(() => {
      this.$refs.Statistics.getEchartsData()
    })
    this.D3Config.Viewer = null;
    if (!this.D3Config.Viewer) {
      this.initScene();
      this.$refs.boxer.init();
      //加载wanhui.glb模型
      //this.$refs.gltf.showModel();
      this.$refs.worker.init();
      //开启报警
      this.iconClick('屏蔽报警');
      window.clickCamera=this.iconClick;
      let self=this;
      setInterval(() => {
        getPolice(this.D3Config.username, this.D3Config.password,null,1).then(res => {//最近1天告警数据
          self.gjDataNum=res.data.data.length;
        });
      }, 6000)

    }
  },
  beforeDestroy() {
    this.fourColorLayer&& this.fourColorLayer.destroy();
    this.workerLayer&& this.workerLayer.destroy();
    this.eleFenceLayer&& this.eleFenceLayer.destroy();
    this.cameraLayer&& this.cameraLayer.destroy();
    this.eleFenceLayer&& this.eleFenceLayer.destroy();
    this.workOrderLayer&& this.workOrderLayer.destroy();
    this.alarmLayer&& this.alarmLayer.destroy();
    this.deviceDataLayer&& this.deviceDataLayer.destroy();
    this.deviceLayer&& this.deviceLayer.destroy();
    this.D3Config.Viewer = null;
    this.wranSetInterval&&clearInterval(this.wranSetInterval);
    this.workerWarnSetInterval&&clearInterval(this.workerWarnSetInterval);
  }
}
</script>
<style scoped>
#gisContainer{
  /* width:100vw; */
  width: calc(100% - 60px);
  /* height:100vh; */
  height: 100%;
  bottom:0px;
  position:absolute;
}
.cesium-widget canvas{
  height:100%;
  width:100%;
}
.switchBox1{
  position:absolute;
  z-index:1002;
  bottom:30%;
  left:290px;
}
.switchBox2{
  position:absolute;
  z-index:1002;
  bottom:30%;
  right:10px;
}
.card-imgs{
  padding: 5px;
  margin-top: 2px;
  cursor: pointer;
}
/deep/ .el-card__body{
  padding: 0 ;
  height: 30px;
}
.card-img{
  /* padding: 10px; */
}
.mapTitle{
  position: absolute;
  z-index: 1003;
  left: 50%;
  transform: translateX(-50%);
  font-size: 25px;
  color:white;
}
</style>
